import React, { useState, useEffect } from "react"
import { FaUser, FaShoppingCart } from "react-icons/fa"
import { Link } from "react-router-dom"
import EmailAttendees from "./EmailAttendess"
import axios from "axios"
import { localserver } from "../../../api/common"
import { showToast, ToastMessage } from "../../Shared/ToastMessage"
import { useUser } from "../../AdminUsers/UserContext"

const Emails = () => {
  const { checkPermission,getValidation } = useUser()
  const [activeTab, setActiveTab] = useState("attendees")
  const [isLoading, setIsLoading] = useState(false)
  const [emailTemplates, setEmailTemplates] = useState([])

  const fetchEmailsTemplate = async (tab) => {
    setIsLoading(true)
    try {
      const response = await axios.post(
        `${localserver}/getEmailTemplates`,
        {
          event_id: localStorage.getItem("eventId"),
          email_type: getActiveComponentId(tab),
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        },
      )

      if (response.data.success && Array.isArray(response.data.data)) {
        const templates = response.data.data.map((email) => ({
          ...email,
          description: `Send an email for ${tab} related to your event`,
          sendTo: email.sender_email,
          isActive: email.is_active,
        }))
        setEmailTemplates(templates)
      } else {
        showToast(`No email templates found for ${tab}.`, "error")
      }
    } catch (error) {
      console.error(`Error fetching email templates for ${tab}:`, error)
      showToast("Failed to fetch email templates. Please try again.", "error")
    } finally {
      setIsLoading(false)
    }
  }

  const getActiveComponentId = (tab) => {
    switch (tab) {
      case "attendees":
        return 1
      case "orders":
        return 2
      case "prepaidOrders":
        return 3
      case "reminders":
        return 4
      default:
        return 1
    }
  }

  const renderActiveComponent = () => {
    return (
      <EmailAttendees
        emailTemplates={emailTemplates}
        isLoading={isLoading}
        activeTab={activeTab}
        fetchEmailsTemplate={fetchEmailsTemplate}
      />
    )
  }

  const handleActiveComponent = (tab) => {
    setActiveTab(tab)
    fetchEmailsTemplate(tab)
  }

  // Check Admin User Permission
  const [checkUserLoading, setCheckUserLoading] = useState(false)
  const fetchPermission = async () => {
    setCheckUserLoading(true)
    try {
      const hasPermission = await checkPermission("Email Settings", "view")
      if (!hasPermission) return
    } catch (error) {
      console.error("Error Check Permission:", error)
    } finally {
      setCheckUserLoading(false)
    }
  }

  useEffect(() => {
    fetchPermission()
  }, [])

  useEffect(() => {
    fetchEmailsTemplate(activeTab)
  }, [])

  const renderHeader = () => (

    <div style={{ marginBottom: "22px" }}>
      <div className="brood_comes_div">
        <div className="row align-items-center">
          <div className="col-md-6 brood_comes_heading">
            <h2>
              <div className="brood_comes_part">
                {/* <FaCheck /> */}
                <i class="fa fa-credit-card"></i>
              </div>
              Event Emails
            </h2>

          </div>
          <div className="col-md-6 text-end">

          </div>
        </div>
      </div>
    </div>
  )

  const renderNavigationTabs = () => (
    <div className="email_page_div" style={{ position: "relative" }}>
      <div className="tab-card-wrapper">
        <button
          className={`tab-card ${activeTab === "attendees" ? "active" : ""}`}
          onClick={() => handleActiveComponent("attendees")}
        >
          <div className="tab-card-icon">
            <FaUser size={18} />
          </div>
          <div className="tab-card-text">
            <span className="tab-card-title">Attendees</span>
            <span className="tab-card-subtitle">Attendee email templates</span>
          </div>
        </button>

        <button
          className={`tab-card ${activeTab === "orders" ? "active" : ""}`}
          onClick={() => handleActiveComponent("orders")}
        >
          <div className="tab-card-icon">
            <FaShoppingCart size={18} />
          </div>
          <div className="tab-card-text">
            <span className="tab-card-title">Orders</span>
            <span className="tab-card-subtitle">Order email templates</span>
          </div>
        </button>
      </div>

    </div>
  )

  const renderMainContent = () => (
    <div style={{ margin: "0 auto" }}>
      <div
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "20px",
          boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)",
          overflow: "hidden",
          border: "1px solid rgba(24, 71, 120, 0.08)",
          position: "relative",
          background: "linear-gradient(135deg, #ffffff 0%, #fafbfc 100%)",
        }}
      >
        <div style={{ padding: "2.5rem" }}>{renderActiveComponent()}</div>
      </div>
    </div>
  )

  return (
    <>
      {checkUserLoading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "500px" }}>
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      ) : (
        <div style={{ minHeight: "100vh", backgroundColor: "#f8fafc", padding: "24px" }}>
          <ToastMessage />
          {renderHeader()}
          {renderNavigationTabs()}
          {renderMainContent()}
        </div>
      )}
    </>
  )
}

export default Emails
